/* eslint-disable */ import { memoEval, sceneEntityRemoteObjectComponent } from '@salsita-ai/platform-project-sdk/domain';
import { attachComponent } from '../implementation.js';
export const baseCabinet3DrawerComponents = [
    attachComponent.withComponent(sceneEntityRemoteObjectComponent, 'default', true).withEntity('BaseCabinet3Drawer').attach(memoEval(()=>[], ()=>({
            fileUrl: '/models/higgins.glb',
            objectName: 'B3D24',
            dimensionUnit: 'inch'
        })))
];

//# sourceMappingURL=base-cabinet-3-drawer.js.map